import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { EmptyList } from "../../components/EmptyList";
import Toast from "../../components/Toast";
import { WithdrawalAnalysisModal } from "../../components/WithdrawalAnalysisModal";
import { useToast } from "../../hooks/useToast";
import { Withdrawal } from "../../interfaces/withdrawal";
import { WithdrawalItem } from "./WithdrawlItem";

interface PendingWithdrawalsProps {
    data: Withdrawal[];
    isLoading: boolean;
    onRefresh: () => void;
}

export function PendingWithdrawals({
    data,
    isLoading,
    onRefresh,
}: PendingWithdrawalsProps) {
    const [openModal, setOpenModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<Withdrawal | null>(null);

    const navigate = useNavigate();

    const { toast, closeToast, updateToast } = useToast();

    const handleEditSuccess = () => {
        onRefresh();

        updateToast({
            open: true,
            severity: "success",
            text: `Saque atualizado com sucesso.`,
        });
    };

    const handleEditError = (data: Withdrawal | null, error?: string) => {
        updateToast({
            open: true,
            severity: "error",
            text: error,
        });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedRow(null);
    };

    const handleOpenModal = (row: Withdrawal) => {
        setSelectedRow(row);
        setOpenModal(true);
    };

    return (
        <>
            <Card
                variant="outlined"
                style={{ height: "100%", minHeight: 300 }}
                sx={{ borderRadius: 2 }}
            >
                <CardContent style={{ height: "100%" }}>
                    <Box display="flex" justifyContent="space-between">
                        <Typography fontWeight={600}>
                            Solicitações de Saque Pendentes
                        </Typography>
                        <Typography
                            variant="body2"
                            color="primary"
                            sx={{ cursor: "pointer" }}
                            onClick={() => navigate("/acquirer/withdrawals")}
                        >
                            Ver todas
                        </Typography>
                    </Box>

                    <Box mt={2} hidden={isLoading || data?.length === 0}>
                        {data?.map((item, index) => (
                            <Box key={item.id}>
                                <WithdrawalItem
                                    data={item}
                                    onClick={() => handleOpenModal(item)}
                                />
                                {index < data.length - 1 && <Divider />}
                            </Box>
                        ))}
                    </Box>

                    <EmptyList
                        title="Nenhuma solicitação de saque pendente encontrada"
                        loading={isLoading}
                        isEmpty={data?.length === 0}
                    />
                </CardContent>
            </Card>

            <WithdrawalAnalysisModal
                open={openModal}
                onClose={handleCloseModal}
                data={selectedRow}
                onSuccess={handleEditSuccess}
                onError={handleEditError}
            />

            <Toast
                open={toast.open}
                onClose={closeToast}
                severity={toast.severity}
                text={toast?.text}
            />
        </>
    );
}
